import React from 'react'
import withAppdata from '../AppConfig/withAppdata'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import { RESERVATION_VIEW_KEY, reservationViewPreference } from '../utils/reservationview'

// Topbar switch on the calendar: on opens a reservation in the side panel next to the calendar,
// off in the old modal. The choice is the user's own preference (see utils/reservationview.js).
function ReservationViewSwitch({ appdata, firebase, iconOnly }) {
  const panel = reservationViewPreference(appdata && appdata.userpreferences) === 'panel'
  const [saving, setSaving] = React.useState(false)

  const toggle = async (event) => {
    setSaving(true)
    try {
      await firebase.savePersonVenueManagerConfigs({ [RESERVATION_VIEW_KEY]: event.target.checked ? 'panel' : 'modal' })
    } catch (error) {
      console.error('Saving the reservation view failed', error)
    }
    setSaving(false)
  }

  return (
    <FormControlLabel
      className='d-none d-lg-inline-flex'
      title='Päällä: varaus avautuu kalenterin viereen. Pois: varaus avautuu ikkunaan.'
      control={<Switch size='small' checked={panel} onChange={toggle} disabled={saving} />}
      label={iconOnly ? 'Paneeli' : 'Varauspaneeli'}
      sx={{ mr: 1.5, mb: 0, '& .MuiFormControlLabel-label': { fontSize: 12 } }}
    />
  )
}

export default withAppdata(ReservationViewSwitch)
